import { Capacitor } from '@capacitor/core';

function toBase64(str: string) {
  if (typeof window !== 'undefined' && typeof window.btoa === 'function') {
    return window.btoa(unescape(encodeURIComponent(str)));
  }
  const buf = require('buffer').Buffer.from(str, 'utf8');
  return buf.toString('base64');
}

export async function saveAndShareCsv(filename: string, csv: string) {
  if (typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
    try {
      const fs = await import('@capacitor/filesystem');
      const Filesystem = fs.Filesystem;
      const Directory = fs.Directory;
      const Share = (await import('@capacitor/share')).Share;

      const base64 = toBase64('\uFEFF' + csv);
      const folder = 'csvs';
      const path = `${folder}/${filename}`;

      try {
        await Filesystem.mkdir({ path: folder, directory: Directory.Documents, recursive: true });
      } catch (mkdirErr) {
        console.debug('mkdir csvs result', mkdirErr);
      }

      await Filesystem.writeFile({ path, data: base64, directory: Directory.Documents });

      const uriResult = await Filesystem.getUri({ path, directory: Directory.Documents });
      const fileUri = (uriResult as any).uri || (uriResult as any).uriPath || uriResult;

      await Share.share({ title: filename, text: filename, url: fileUri, dialogTitle: 'Share CSV' });
      return { success: true, uri: fileUri };
    } catch (e) {
      console.warn('saveAndShareCsv native error', e);
      return { success: false, error: e };
    }
  } else {
    try {
      const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      return { success: true };
    } catch (e) {
      console.warn('saveAndShareCsv web error', e);
      return { success: false, error: e };
    }
  }
}

export default { saveAndShareCsv };
